/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { HubSpotLifecycleRequestFirstname } from './hubSpotLifecycleRequestFirstname';
import type { HubSpotLifecycleRequestLastname } from './hubSpotLifecycleRequestLastname';
import type { HubSpotLifecycleRequestHubspotContactId } from './hubSpotLifecycleRequestHubspotContactId';

/**
 * Finish/Drop (and webhook v1 translator) — flat SKUs, no extras.
 */
export interface HubSpotLifecycleRequest {
  /** Student email address (Primary ID) */
  email: string;
  /** Student's first name (required for initial enrollment) */
  firstname?: HubSpotLifecycleRequestFirstname;
  /** Student's last name (required for initial enrollment) */
  lastname?: HubSpotLifecycleRequestLastname;
  /** List of SKU/Product IDs from HubSpot */
  externalProductIds: string[];
  /** The HubSpot Deal ID for audit trail */
  hubspotDealId: string;
  /** The HubSpot Contact ID for reference */
  hubspotContactId?: HubSpotLifecycleRequestHubspotContactId;
}
